export default {
	PAY_TYPE_FULL: 'full',
	PAY_TYPE_PARTIAL: 'part',
	OTP_TRANSACTIONS_COUNT: 6,
	OTHER_FINANCIAL_ACCOUNTS_COUNT: 6,
	CONNECTION_TYPE: {
		CASH: {
			id: 3,
			class: 'cash',
			name: ['cashIn', 'cashOut']
		},
		BANK_CARD: {
			id: 9,
			class: 'cash',
			name: ['bankCard']
		},
		CHECK: {
			id: 10,
			class: 'cash',
			name: ['check']
		},
		COLLECT_ON_DELIVERY: {
			id: 11,
			class: 'cash',
			name: ['collectOnDelivery']
		},
		GIFT_CARD: {
			id: 12,
			class: 'cash',
			name: ['giftCard']
		},
		BARTER: {
			id: 13,
			class: 'cash',
			name: ['barter']
		},
		DIRECT_DEBID: {
			id: 14,
			class: 'cash',
			name: ['directDebid']
		},
		OTP_SIMPLE: {
			id: 15,
			class: 'cash',
			name: ['otpSimple']
		},
		COMPENSATION: {
			id: 16,
			class: 'cash',
			name: ['compensation']
		},
		COUPON: {
			id: 17,
			class: 'cash',
			name: ['coupon']
		},
		PAYPAL: {
			id: 18,
			class: 'cash',
			name: ['paypal']
		},
		PAYU: {
			id: 19,
			class: 'cash',
			name: ['payU']
		},
		SZEP_CARD: {
			id: 20,
			class: 'cash',
			name: ['szepCard']
		},
		VOUCHER: {
			id: 21,
			class: 'cash',
			name: ['voucher']
		},
		STORNO: {
			id: 23,
			class: 'cash',
			name: ['storno']
		},
		CANT_PAID: {
			id: 22,
			class: 'cash',
			name: ['cantPaid']
		},
		BANK_TRANSACTION: {
			id: 1,
			class: 'default',
			name: ['otpFinancialAccount']
		},
		OTHER_BANK_ACCOUNT: {
			id: 5,
			class: 'other',
			name: ['otherFinancialAccount']
		},
		OTHER: {
			id: 8,
			class: 'other',
			name: ['other']
		},
		REDUCTION: {
			id: 24,
			class: 'cash',
			name: ['reduction']
		},
		HEALTH_INSURANCE_CARD: {
			id: 25,
			class: 'cash',
			name: ['healthInsuranceCard']
		}
	}
};
